import React from 'react';
 
 export const renderHTML = (rawHTML) => {
  
  return React.createElement("div",{style: {textAlign:"justify"}, dangerouslySetInnerHTML: { __html: rawHTML } })};